var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        fill: "#F09A0FFF",
        version: "1.1",
        id: "Layer_1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        viewBox: "0 0 512.001 512.001",
        "xml:space": "preserve",
        width: "20px",
        height: "20px",
      },
    },
    [
      _c("g", { attrs: { id: "SVGRepo_bgCarrier", "stroke-width": "0" } }),
      _vm._v(" "),
      _c("g", {
        attrs: {
          id: "SVGRepo_tracerCarrier",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
        },
      }),
      _vm._v(" "),
      _c("g", { attrs: { id: "SVGRepo_iconCarrier" } }, [
        _c("g", [
          _c("g", [
            _c("polygon", {
              attrs: {
                points:
                  "399.709,183.821 399.709,152.466 384.032,152.466 384.032,231.898 399.709,231.898 399.709,199.498 416.432,199.498 416.432,183.821 ",
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("g", [
            _c("polygon", {
              attrs: {
                points:
                  "111.246,152.466 111.246,183.821 95.569,183.821 95.569,199.498 111.246,199.498 111.246,231.898 126.924,231.898 126.924,152.466 ",
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("g", [
            _c("path", {
              attrs: {
                d: "M255.847,0C176.51,0,111.965,64.545,111.965,143.881h15.677c0-70.692,57.513-128.204,128.204-128.204 c70.692,0,128.204,57.512,128.204,128.204h15.677C399.728,64.545,335.184,0,255.847,0z",
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("g", [
            _c("rect", {
              attrs: {
                x: "135.286",
                y: "255.938",
                width: "15.677",
                height: "24.039",
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("g", [
            _c("path", {
              attrs: {
                d: "M264.013,247.576c0.001,5.226-3.662,8.166-8.166,8.166c-4.504,0-8.166-2.94-8.166-8.166h-15.677 c0,13.587,10.696,23.843,23.843,23.843c13.147,0,23.843-10.256,23.843-23.843H264.013z",
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("g", [
            _c("rect", {
              attrs: {
                x: "192.77",
                y: "128.429",
                width: "45.987",
                height: "15.677",
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("g", [
            _c("rect", {
              attrs: {
                x: "273.247",
                y: "96.029",
                width: "38.671",
                height: "15.677",
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("g", [
            _c("path", {
              attrs: {
                d: "M358.957,416.13h-55.401v-22.469c24.142-15.676,40.155-42.858,40.155-73.725V247.75h32.01V136.043h-32.01v-8.167 c0-48.448-39.415-87.863-87.863-87.863s-87.864,39.415-87.864,87.863v8.167h-32.01V247.75h32.01v72.186 c0,1.406,0.041,2.801,0.107,4.19c-10.066-8.837-16.439-21.784-16.439-36.2h-15.677c0,25.126,14.591,46.899,35.741,57.316 c6.038,20.036,19.049,37.065,36.203,48.277l-0.213,22.611h-54.966c-22.482,0-40.773,18.29-40.773,40.772v55.094h15.677v-55.094 c0-13.837,11.257-25.094,25.095-25.094h55.258v8.166c0,23.403,16.892,42.921,39.121,47.038v24.988h15.677v-24.684 c23.103-3.376,40.904-23.315,40.904-47.34v-8.166h55.258c13.837,0,25.094,11.257,25.094,25.094v55.094h15.677v-55.094 C399.728,434.42,381.438,416.13,358.957,416.13z M343.711,151.72h16.333v80.353h-16.333V151.72z M167.984,232.073h-16.333V151.72 h16.333V232.073z M183.659,127.876c0.002-39.804,32.384-72.186,72.188-72.186c39.804,0,72.186,32.382,72.186,72.186v40.548 c-7.255-9.917-18.972-16.375-32.174-16.375c-19.207,0-35.281,13.659-39.025,31.773h-1.975 c-3.743-18.115-19.818-31.773-39.025-31.773c-13.202,0-24.919,6.458-32.174,16.375V127.876z M320.031,191.896 c0,13.328-10.844,24.171-24.171,24.171s-24.171-10.844-24.171-24.171s10.844-24.171,24.171-24.171 S320.031,178.568,320.031,191.896z M240.006,191.896c0,13.328-10.843,24.171-24.171,24.171c-13.328,0-24.171-10.844-24.171-24.171 s10.843-24.171,24.171-24.171C229.163,167.725,240.006,178.568,240.006,191.896z M288.02,439.975 c0.001,17.739-14.432,32.173-32.173,32.173c-17.74,0-32.174-14.434-32.174-32.174v-23.843h-0.293l0.137-14.519 c10.014,3.978,20.915,6.189,32.329,6.189c11.301,0,22.099-2.168,32.031-6.071v21.433h0.143V439.975z M255.847,392.123 c-28.638,0-53.435-16.765-65.092-40.996c2.966,0.424,5.993,0.656,9.075,0.656h17.499c3.25,9.307,12.111,16.004,22.514,16.004 c13.148,0,23.843-10.696,23.843-23.843c0-0.055-0.004-0.109-0.004-0.164h20.174c15.353,0,27.845-12.491,27.845-27.845 c0-15.354-12.492-27.845-27.845-27.845h-56.017c-15.353,0-27.845,12.492-27.845,27.845c0,7.932,3.339,15.093,8.678,20.169h-8.843 c-5.172,0-10.153-0.829-14.826-2.344c-0.872-4.477-1.343-9.096-1.343-13.824V215.369c7.255,9.917,18.973,16.376,32.174,16.376 c19.373,0,35.553-13.898,39.113-32.247h1.8c3.56,18.348,19.74,32.247,39.113,32.247c13.202,0,24.919-6.458,32.174-16.376v104.567 C328.033,359.74,295.651,392.123,255.847,392.123z M239.842,320.1c-6.573,0-12.532,2.674-16.85,6.99 c-4.303-1.877-7.321-6.167-7.321-11.154c0-6.709,5.458-12.168,12.168-12.168h56.017c6.709,0,12.168,5.459,12.168,12.168 s-5.459,12.168-12.168,12.168h-26.214C253.273,323.197,246.914,320.1,239.842,320.1z M248.008,343.943 c0,4.504-3.663,8.166-8.166,8.166c-4.503,0-8.166-3.663-8.166-8.166c0-4.503,3.663-8.166,8.166-8.166 C244.345,335.777,248.008,339.441,248.008,343.943z",
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("g", [
            _c("rect", {
              attrs: {
                x: "208.447",
                y: "183.822",
                width: "14.632",
                height: "15.677",
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("g", [
            _c("rect", {
              attrs: {
                x: "287.879",
                y: "183.822",
                width: "15.677",
                height: "15.677",
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("g", [
            _c("rect", {
              attrs: {
                x: "280.563",
                y: "496.324",
                width: "14.632",
                height: "15.677",
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("g", [
            _c("rect", {
              attrs: {
                x: "159.325",
                y: "487.962",
                width: "15.677",
                height: "24.039",
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("g", [
            _c("rect", {
              attrs: {
                x: "335.956",
                y: "487.962",
                width: "15.677",
                height: "24.039",
              },
            }),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }